import * as React from 'react';
import clsx from 'clsx';

interface BadgeProps {
  label: string | number;
  icon?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'transparent' | 'chatHeader';
}

/** Pill-shaped badge with optional leading icon. `variant` swaps the visual treatment for chat headers etc. */
export const Badge: React.FC<BadgeProps> = ({ label, icon, className, variant = 'default' }) => {
  const isChatHeader = variant === 'chatHeader';
  const isDefault = variant === 'default';

  const backgroundStyle =
    isDefault || isChatHeader
      ? {
          background:
            'linear-gradient(0deg, rgba(26, 16, 54, 0.2), rgba(26, 16, 54, 0.2)), linear-gradient(0deg, #3F297A, #3F297A)',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
        }
      : undefined;

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-30',
        isChatHeader
          ? 'size-auto gap-1 px-[10px] py-[5px] font-sans text-[12px] font-medium leading-105 tracking-normal text-white'
          : 'h-[29px] w-[79px] gap-1 font-sans text-12 font-medium leading-nav tracking-normal text-white',
        (isDefault || isChatHeader) && 'backdrop-blur-[44px]',
        variant === 'transparent' && 'bg-transparent',
        className
      )}
      style={backgroundStyle}
    >
      <span className={isChatHeader ? '' : 'mt-px'}>{label}</span>
      {icon && (
        <span
          className={clsx('flex shrink-0 items-center justify-center', !isChatHeader && 'mt-px')}
        >
          {icon}
        </span>
      )}
    </div>
  );
};

export default Badge;
